import React, { useEffect, useState } from "react";
import { Card, Descriptions, Spin, message } from "antd";
import { useParams } from "react-router-dom";
import { apiService } from "@/services/api";

export const GenreShow: React.FC = () => {
  const { id } = useParams();
  const [genre, setGenre] = useState<any | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await apiService.getGenres();
        const g = (data as any[]).find((x: any) => String(x.id) === String(id));
        setGenre(g);
      } catch (e) {
        message.error("Impossible de charger le genre");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  if (loading) return <Spin />;
  if (!genre) return null;

  return (
    <Card title={`Genre #${genre.id}`}>
      <Descriptions bordered column={1}>
        <Descriptions.Item label="Nom">{genre.name}</Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default GenreShow;
